import { API } from "./api";

export const track = (slug, payload) => {
  try {
    fetch(`${API}/public/cards/${slug}/events`, {
      method: "POST", keepalive: true, credentials: "include",
      headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
    }).catch(() => {});
  } catch {
    // tracking must never break the card
  }
};
